<div
  class="grid h-full grid-cols-1 divide-y divide-gray-200 sm:grid-cols-3 sm:divide-x sm:divide-y-0"
>
  @for (tile of tiles(); track tile.label) {
    <a
      routerLink="/analytics/historical-observations"
      [queryParams]="{ labels: tile.actionLabelId }"
      class="flex flex-col text-inherit no-underline transition-colors outline-none hover:bg-gray-50/90 focus-visible:bg-gray-50/90 focus-visible:ring-2 focus-visible:ring-inset"
      [attr.aria-describedby]="'tile-' + tile.actionLabelId"
      [ngClass]="{
        'hover:bg-iq-observe/20 focus-visible:ring-iq-observe':
          tile.actionLabelId === 'OBSERVE',
        'hover:bg-iq-investigate/20 focus-visible:ring-iq-investigate':
          tile.actionLabelId === 'INVESTIGATE',
        'hover:bg-iq-monitor/20 focus-visible:ring-iq-monitor':
          tile.actionLabelId === 'MONITOR',
      }"
    >
      <div class="h-1" [ngClass]="tile.accentBarClass"></div>
      <div
        class="flex h-full flex-col px-4 pb-4"
        [id]="'tile-' + tile.actionLabelId"
      >
        <h3 class="py-2 text-start text-lg font-medium">
          {{ tile.label }}
        </h3>
        <span
          class="flex-1 text-center text-[6rem] font-medium"
          [ngClass]="tile.accentTextClass"
        >
          {{ tile.count | number }}
        </span>
        @if (tile.rate !== null) {
          <div
            class="mt-2 flex items-center gap-1"
            [ngClass]="getTrendClass(tile.rate)"
          >
            <mat-icon
              aria-hidden="true"
              class="! h-4.5! w-4.5! text-lg! leading-4"
            >
              {{ getTrendIcon(tile.rate) }}
            </mat-icon>
            <span class="text-xs font-medium">
              {{ tile.rate.changePercent > 0 ? '+' : ''
              }}{{ tile.rate.changePercent | number: '1.1-1' }}%
            </span>
            <span class="text-xs">vs prev. period</span>
          </div>
        }
      </div>
    </a>
  }
</div>
